core.constant('officeMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "GRID" : {
          "PLACEHOLDER" : "Wpisz nazwę gabinetu, ulicę lub miejscowość",
          "ITEMS_PER_PAGE" : "Elementów na stronę"
        },
        "TAB": {
        },
        "BREADCRUMB": {
        },
        "APPLICATION" : {
          "NEW_OFFICE" : "Nowy gabinet",
          "EDIT_OFFICE" : "Edycja gabinetu"
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "OFFICE": {
          "OFFICE_DELETE_CONFIRMATION" : "Czy chcesz usunąć gabinet?",
          "OFFICE_NAME" : "Nazwa gabinetu",
          "OFFICES" : "Gabinety",
          "ADDRESS" : "Adres",
          "SEARCH_BOX" : "Wpisz nazwę gabinetu, ulicę lub miejscowość",
          "ACTION" : "Akcje",
          "OFFICE_LOCALISATION" : "Lokalizacja gabinetu",
          "OFFICE_DATA": "Dane gabinetu",
          "FULL_NAME" : "Nazwa gabinetu",
          "STREET" : "Ulica",
          "FLAT_NUMBER" : "Nr domu",
          "APARTMENT" : "Numer mieszkania",
          "POST_CODE" : "Kod pocztowy",
          "CITY" : "Miasto",
          "STATE" : "Województwo",
          "LANDLINE_REGISTRATION" : "Nr telefonu stacjonarnego rejestracji",
          "MOBILE_PHONE_NUMBER_REGISTRATION" : "Nr telefonu komórkowego rejestracji",
          "EMAIL" : "Email",
          "WWW" : "Strona www",
          "ORGANIZATIONAL_UNIT" : "Jednostka organizacyjna",
          "RESORT_CODE_V" : "Kod resortowy V",
          "RESORT_CODE_VII" : "Kod resortowy VII",
          "COLOUR_IN_CALENDAR" : "Kolor przypisany w kalendarzu",
          "PRICING_AND_SERVICE_LIST" : "Cennik i zakres usług",
          "CHOOSE_SERVICE" : "Wybierz usługę",
          "SERVICE_PRICE" : "Koszt usługi",
          "DEFAULT_APPOINTMENT_LENGTH" : "Standardowa długość wizyty",
          "INVALID_PRICE" : "Niepoprawna wartość ceny",
          "PLACE_OF_SUPPLY_OF_SERVICES_CODE": "Kod miejsca wykonywania świadczeń"
        },
        "REPORT": {
          "RANGE": "Zakres",
          "DATE_FROM": "Data od",
          "DATE_TO": "Data do",
          "VISIT_BOOK": "Księga wizyt"
        }
      }
    }
  }
});
